export default {
  namespaced: true,
  state: () => ({
    isFullScreen: false,
  }),
  mutations: {
    isFullScreen(state, val) {
      state.isFullScreen = val;
      console.log(state.isFullScreen);
    },
  },
  actions: {
    isFullScreen({ commit }, val) {
      // this.isBetaPopup = val;
      commit("isFullScreen", val);
    },
  },
  getters: {},
};
